import React, { useEffect, useState } from "react";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Import images
import photo from "../../../Assets/Home/frame one .png";
import photoOne from "../../../Assets/Home/Dream Temple.png";
import photoTwo from "../../../Assets/Home/Dream Murtis.png";
import photoThree from "../../../Assets/Home/Sculptures.png";
import photoFour from "../../../Assets/Home/Home Decor.png";
import photoFive from "../../../Assets/Home/sideimage.png";
import Offer from "../../../Assets/Home/clay.png";
import offerone from "../../../Assets/Home/vintageOne.png";
import offertwo from "../../../Assets/Home/vintage.png";

const CompleteHomeSection = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";
  
  const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
    });

    fetchBlogs();
  }, []);

  // Helper function to get localized text
  const getLocalizedText = (item, field) => {
    if (!item || !item[field]) return "";
    
    // If value is a string (backward compatibility with old blogs)
    if (typeof item[field] === 'string') {
      return item[field];
    }
    
    // If value is an object with language keys
    if (typeof item[field] === 'object') {
      return item[field][currentLanguage] || 
             item[field].en || 
             item[field].hi || 
             item[field].es || 
             item[field].zh || 
             "";
    }
    
    return "";
  };

  const fetchBlogs = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/blog/get-all-blog`
      );
      setBlogs(response.data);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  // Re-fetch blog titles when language changes
  useEffect(() => {
    if (blogs.length > 0) {
      const updatedBlogs = blogs.map(blog => ({
        ...blog,
        localizedTitle: getLocalizedText(blog, "title"),
        localizedContent: getLocalizedText(blog, "content")
      }));
      setBlogs(updatedBlogs);
    }
  }, [currentLanguage, blogs.length]);

  const getLocalizedDecorTitle = (key) => {
    return t(`decor_items.${key}`) || key;
  };

  const decorItems = [
    {
      src: photo,
      title: "wall_decor",
      displayTitle: "Wall Decor",
      height: "h-[350px]",
    },
    {
      src: photoOne,
      title: "temple_decor",
      displayTitle: "Temple Decor",
      height: "h-[200px]",
    },
    {
      src: photoTwo,
      title: "outdoor_decor",
      displayTitle: "Outdoor Decor",
      height: "h-[200px]",
    },
    {
      src: photoThree,
      title: "outdoor_decor_2",
      displayTitle: "Outdoor Decor",
      height: "h-[350px]",
    },
    {
      src: photoFour,
      title: "home_decor",
      displayTitle: "Home Decor",
      height: "h-[350px]",
    },
    {
      src: photoOne,
      title: "temple_decor_2",
      displayTitle: "Temple Decor",
      height: "h-[200px]",
    },
  ];

  const discounts = [
    {
      id: 1,
      titleKey: "discount_card_title_1",
      subtitleKey: "discount_card_subtitle_1",
      daysKey: "discount_card_days_1",
      defaultTitle: "Get A 10% Discount",
      defaultSubtitle: "On Payday Week",
      defaultDays: "LEARN MORE",
      image: Offer,
      color: "bg-gray-100",
    },
    {
      id: 2,
      titleKey: "discount_card_title_2",
      subtitleKey: "discount_card_subtitle_2",
      daysKey: "discount_card_days_2",
      defaultTitle: "Get A 10% Discount",
      defaultSubtitle: "On Payday Week",
      defaultDays: "LEARN MORE",
      image: offerone,
      color: "bg-gray-100",
    },
    {
      id: 3,
      titleKey: "discount_card_title_3",
      subtitleKey: "discount_card_subtitle_3",
      daysKey: "discount_card_days_3",
      defaultTitle: "Get A 10% Discount",
      defaultSubtitle: "On Payday Week",
      defaultDays: "LEARN MORE",
      image: offertwo,
      color: "bg-gray-100",
    },
  ];

  // Helper function to get localized discount text with fallback
  const getLocalizedDiscountText = (key, fallback) => {
    return t(key) || fallback;
  };

  // Get blog title with fallback
  const getBlogTitle = (blog) => {
    if (blog.localizedTitle) {
      return blog.localizedTitle;
    }
    return getLocalizedText(blog, "title") || blog.title || t("untitled_blog");
  };

  // Get blog content with fallback
  const getBlogContent = (blog) => {
    if (blog.localizedContent) {
      return blog.localizedContent;
    }
    return getLocalizedText(blog, "content") || blog.content || "";
  };

  return (
    <div className="w-full mx-auto px-4 md:px-10 pt-10">
      {/* Trending Now Section */}
      <div
        className="grid md:grid-cols-2 gap-8 mb-10 rounded-md shadow-lg bg-white"
        data-aos="fade-up"
      >
        <div className="flex flex-col justify-center p-4">
          <h2 className="text-3xl md:text-4xl font-philosopher mb-4">
            {t("trending_now_titles") || "TRENDING NOW"}
          </h2>
          <p className="text-gray-600 mb-6 leading-relaxed font-poppins">
            {t("trending_now_description") ||
              "Hand Pour Lamp Standing Home Decoration Floor collapsing, Metal Floor Lamp Standing Home Decoration Floor Lamp Standing Floor Just lamp."}
          </p>
          <button className="bg-black text-white rounded px-8 py-3 w-fit hover:bg-gray-800 transition-colors">
            {t("shop_now") || "Shop Now"}
          </button>
        </div>
        <div className="relative">
          <img
            src={photoFive}
            alt={t("trending_statues_alt") || "Trending statues"}
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      {/* Category Grid */}
      <div
        className="w-full bg-white flex flex-col md:flex-row justify-center items-stretch gap-6 pb-10"
        data-aos="fade-up"
      >
        {/* Left column */}
        <div className="flex flex-col justify-center items-center w-full md:w-1/3 gap-6">
          {decorItems.slice(0, 2).map((item, i) => {
            const localizedTitle = getLocalizedDecorTitle(item.title);
            return (
              <div key={i} className="relative w-full" data-aos="fade-right">
                <img
                  src={item.src}
                  alt={localizedTitle}
                  className={`${item.height} w-full object-cover rounded-xl shadow-md`}
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-40 text-white text-center py-2 rounded-b-xl font-medium">
                  {localizedTitle}
                </div>
              </div>
            );
          })}
        </div>

        {/* Middle column */}
        <div
          className="flex flex-col justify-between w-full md:w-1/3 gap-6"
          data-aos="zoom-in"
        >
          {decorItems.slice(2, 4).map((item, i) => {
            const localizedTitle = getLocalizedDecorTitle(item.title);
            return (
              <div key={i} className="relative w-full" data-aos="fade-right">
                <img
                  src={item.src}
                  alt={localizedTitle}
                  className={`${item.height} w-full object-cover rounded-xl shadow-md`}
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-40 text-white text-center py-2 rounded-b-xl font-medium">
                  {localizedTitle}
                </div>
              </div>
            );
          })}
        </div>

        {/* Right column */}
        <div
          className="flex flex-col justify-between w-full md:w-1/3 gap-6"
          data-aos="fade-left"
        >
          {decorItems.slice(4, 6).map((item, i) => {
            const localizedTitle = getLocalizedDecorTitle(item.title);
            return (
              <div key={i} className="relative w-full" data-aos="fade-right">
                <img
                  src={item.src}
                  alt={localizedTitle}
                  className={`${item.height} w-full object-cover rounded-xl shadow-md`}
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-40 text-white text-center py-2 rounded-b-xl font-medium">
                  {localizedTitle}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Discount Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10 cursor-pointer">
        {discounts.map((disc, index) => {
          const title = getLocalizedDiscountText(disc.titleKey, disc.defaultTitle);
          const subtitle = getLocalizedDiscountText(disc.subtitleKey, disc.defaultSubtitle);
          const days = getLocalizedDiscountText(disc.daysKey, disc.defaultDays);

          return (
            <div
              key={disc.id}
              className={`${disc.color} rounded-lg p-6 flex items-center gap-4 shadow-md hover:shadow-xl transition-all duration-300`}
              data-aos="fade-up"
              data-aos-delay={index * 150}
            >
              <div className="flex-1">
                <h3 className="text-lg md:text-xl font-bold mb-1">{title}</h3>
                <p className="text-sm text-gray-700 mb-3">{subtitle}</p>
                <p className="text-xs font-semibold text-gray-600">{days}</p>
              </div>
              <div className="w-24 h-24 md:w-32 md:h-32 flex-shrink-0">
                <img
                  src={disc.image}
                  alt={title}
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          );
        })}
      </div>

      {/* Blog Section */}
      <div className="pb-10" data-aos="fade-up">
        <div className="text-center mb-6">
          <h2 className="text-3xl md:text-4xl font-philosopher">
            {t("latest_blogs") || "LATEST BLOGS"}
          </h2>
          <div className="ornament-divider mx-auto mt-2 mb-4"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {blogs.map((blog, index) => {
            const blogTitle = getBlogTitle(blog);
            const blogContent = getBlogContent(blog);
            
            return (
              <div
                key={blog._id}
                className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="relative overflow-hidden h-48">
                  <img
                    src={blog.image}
                    alt={blogTitle}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                    onError={(e) => {
                      e.target.src = "https://via.placeholder.com/400x250?text=Blog+Image";
                    }}
                  />
                </div>
                <div className="p-4">
                  <h3 className="font-bold text-lg mb-2 line-clamp-1">
                    {blogTitle}
                  </h3>
                  <p className="text-sm text-gray-600 mb-3 line-clamp-3 leading-relaxed">
                    {blogContent}
                  </p>
                  <div className="flex justify-between items-center text-xs text-gray-500 mb-2">
                    <span>{t("by_author", { author: blog.author || "Admin" })}</span>
                    <span>{new Date(blog.createdAt).toLocaleDateString()}</span>
                  </div>
                  <button
                    onClick={() => navigate(`/blog-details/${blog._id}`)}
                    className="text-sm cursor-pointer font-semibold text-orange-500 hover:text-orange-600 transition-colors"
                  >
                    {t("read_more") || "Read More ›"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <style>{`
        .ornament-divider {
          background-image: url("data:image/svg+xml,%3Csvg width='100' height='20' viewBox='0 0 100 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M50 10 L45 5 L40 10 L45 15 Z M50 10 L55 5 L60 10 L55 15 Z M35 10 L30 7 L25 10 L30 13 Z M65 10 L70 7 L75 10 L70 13 Z M20 10 L18 8 L16 10 L18 12 Z M80 10 L82 8 L84 10 L82 12 Z' fill='%23999' stroke='%23999' stroke-width='0.5'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: center;
          height: 30px;
          width: 100px;
        }
      `}</style>
    </div>
  );
};

export default CompleteHomeSection;